var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.891 17.134c.588.591 1.547.588 2.134-.003a1.523 1.523 0 00-.003-2.14 3.899 3.899 0 010-5.513l4.565-4.594a3.84 3.84 0 015.478 0 3.899 3.899 0 010 5.513 1.523 1.523 0 00-.003 2.14c.587.591 1.546.595 2.134.004 2.739-2.757 2.739-7.044 0-9.8C21.826 1.516 20.152.75 18.326.75s-3.5.613-4.87 1.99L8.892 7.335c-2.739 2.757-2.739 7.044 0 9.8zM2.804 23.26c1.37 1.225 3.044 1.991 4.87 1.991s3.652-.766 4.87-1.99l4.565-4.594c2.739-2.757 2.739-7.044 0-9.8a1.506 1.506 0 00-2.134.003 1.523 1.523 0 00.003 2.14 3.899 3.899 0 010 5.513l-4.565 4.594a3.84 3.84 0 01-5.478 0 3.899 3.899 0 010-5.513c.585-.59.589-1.55.003-2.14a1.506 1.506 0 00-2.134-.004c-2.739 2.757-2.739 7.044 0 9.8z",
    fill: "#005FFF"
  })));
}
export default SvgLinkIcon;